import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";

import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import {
  LastPage,
  AllInclusive,
  Add,
  MoreVert,
  Schedule,
  Block,
  Subway,
  AirportShuttle,
  Edit,
  Delete,
  Done,
  Image
} from "@material-ui/icons";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,DatePicker
} from "@material-ui/pickers";

import {
  TableRow,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  Grid,
  List,ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  CircularProgress,
  FormHelperText,Stepper,Step,StepLabel,
  ListItemSecondaryAction,Popover
} from "@material-ui/core";

import { withLocalize, Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";
import API from './api';

import API_ADMIN from './api_admin';

import UserInfo from "./login_info";

import { useSnackbar } from 'notistack';

import axios from 'axios';

import {TransportService,AdminService} from "./../../utils/web_config_2";

import {useHistory } from "react-router-dom";


import Format from "date-fns/format";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  type_list:{
    backgroundColor: theme.palette.background.paper,
  },
  btn: {
    textTransform: "capitalize",
    margin:theme.spacing(1)
  },
  formTitle: {
    flexGrow: 1,
  },
}));

function Vehicle() {
  const classes = useStyles1();
  const [message,setMessage]=useState("No vehicle found");
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [title,setTitle]=useState("All vehicles");

  const [operatorData, setOperatorData] = useState({});
  
  const history = useHistory();

  // new vehicle dialog

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // add lisence dialog

  const [openLisence, setOpenLisence] = useState(false);

  const handleClickOpenLisence = () => {
    setOpenLisence(true);
  };

  const handleCloseLisence = () => {
    setOpenLisence(false);
  };

  const [selectedDate, setSelectedDate] = React.useState(
    new Date("2014-08-18T21:11:54")
  );

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const columns = [
    
    {
      name: "id",
      label: "id",
      options: {
        display:false,
       filter: true,
       sort: true,
      }
     },
     {
      name: "admin_id",
      label: "admin id",
      options: {
        display:false,
       filter: true,
       sort: true,
      }
     },
    {
     name: "plate_number",
     label: <Translate id="operator_vehicle.table.plate_number" />,
     options: {
      filter: true,
      sort: true,
     }
    },
    {
      name: "vehicle_type",
      label: <Translate id="operator_vehicle.table.vehicle_type" />,
      options: {
       filter: true,
       sort: false,
      }
     },
    {
     name: "vehicle_type_id",
     label: <Translate id="operator_vehicle.table.vehicle_type" />,
     options: {
      filter: true,
      sort: false,
      display:false
     }
    },
    {
      name: "chassis_number",
      label: "Chassis Number",
      options: {
       filter: true,
       sort: false,
      }
     }, 
     {
      name: "steering_side",
      label: "Steering side",
      options: {
       filter: true,
       sort: false,
      }
     },   
     {
      name: "bus_type",
      label: "Bus type",
      options: {
       filter: true,
       sort: false,
      }
     },
     {
      name: "capacity",
      label: <Translate id="operator_vehicle.table.capacity" />,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "vehicle_status",
      label: <Translate id="operator_vehicle.table.status" />,
      options: {
       filter: true,
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <Chip
          variant="outlined"
        label={value}
        onDelete={()=>{}}
        deleteIcon={<Done />}
        color="primary"
      />
        );
      }
      }
     }
   ];
  
  
   
   const options = {
    textLabels: {
      body: {
        noMatch: message
      },
    },
     filterType: 'checkbox',
     download:true,
     responsive:"standard",
     selectableRows:"single",
     rowsPerPage: 10,
     elevation:0,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <Box>
   <Button className={classes.btn} variant="outlined" color="primary" onClick={()=>{
     var id=displayData[selectedRows.data[0]['index']]['data'][0];
     
     setVehicleId(id);
     handleClickOpenLisence();
 
     }}>
        Add lisence
      </Button>

      {/* <Button className={classes.btn} variant="outlined" color="primary" onClick={()=>{  }}>
        View Tickets
      </Button> */}


      <Button className={classes.btn} variant="outlined" color="secondary" onClick={()=>{

       
          var id=displayData[selectedRows.data[0]['index']]['data'][0];
          var obj=vehicles.find((o)=>o.id==id);
       
          setCapacity({value:obj.capacity,error:""});
          setPlateNumber({value:obj.plate_number,error:""});
          setChassisNumber({value:obj.chassis_number,error:""});
          setTypeId({value:obj.vehicle_type_id,error:""});
          setSteeringSide({value:obj.steering_side,error:""});
          setBusType({value:obj.bus_type,error:""});
          setMember({value:obj.cooperative_member_id,error:""})
        
          setVehicleId(id);

          setEditDialog(true);
        
        }}>
         Edit Vehicle
      </Button>

      <Button className={classes.btn} variant="outlined" color="secondary" onClick={()=>{

       
var id=displayData[selectedRows.data[0]['index']]['data'][0];
// var obj=vehicles.find((o)=>o.id==id);

// setCapacity({value:obj.capacity,error:""});
// setPlateNumber({value:obj.plate_number,error:""});
// setChassisNumber({value:obj.chassis_number,error:""});
// setTypeId({value:obj.vehicle_type_id,error:""});
// setSteeringSide({value:obj.steering_side,error:""});

setVehicleId(id);

// setEditDialog(true);

}}>
Remove Vehicle
</Button>
        </Box>
    ),
   };
  
   const [filter,setFilter]=useState(false);
  
   useEffect(()=>{
    var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }
    setOperatorData(data);

    get_vehicle_type(data.token);
    getVehicle(data.token);
    get_lisences(data.token);
    get_route(data.token);
    get_members(data.token)
    
   },[]);


   const [members,setMembers]=useState([]);
   const [member,setMember]=useState({value:"",error:""});

   const get_members=(token)=>{
     axios.defaults.baseURL = new AdminService().BASE_URL;
     const rolesInstance = axios.create(new AdminService().setHeaders(token));
     rolesInstance.get('/api/v1/cooperative-members/organization/'+new UserInfo().ORG_ID+"?size=10000"
     ).then(res=>{
      var dd=res.data.data;

      //loop through dd with foreach
      dd=dd.map((e)=>{
        e["user_first_name"]=e.user['user_first_name']
        e["user_last_name"]=e.user['user_last_name']
        return e;
      })


       setMembers(dd);
     }).catch(err=>{
       console.log(err);
     })
   
   }

   // get vehicle
  
   const [loadVehicle,setLoadvehicle]=useState(false);
   const[vehicles,setVehicles]=useState([]);
   const getVehicle=(token)=>{
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const vehiclesInstance = axios.create(new AdminService().setHeaders(token));
    setLoadvehicle(true);
    vehiclesInstance.get("/api/v1/operator-vehicle/organization/"+new UserInfo().ORG_ID+"/status/ENABLED"
     ).then(res=>{
       console.log("vehicles");
       console.log(res.data.data);
       setLoadvehicle(false);
       if(res.status==200){
         res.data.data.length==0&&setMessage("No Vehicle available");
         var objs=res.data.data;
         objs.map((o)=>{
           o['id']=o['vehicle']['vehicle_id'];
           o['admin_id']=o['vehicle']['vehicle_id'];
           o['capacity']=o['vehicle']['capacity'];
           o['plate_number']=o['vehicle']['plate_number'];
           o['chassis_number']=o['vehicle']['chassis_number'];
           o['steering_side']=o['vehicle']['steering_side'];
           o['vehicle_type_id']=o['vehicle']['vehicle_type']['vehicle_type_id'];
           o['vehicle_type']=o['vehicle']['vehicle_type']['name'];
           o['capacity']=o['vehicle']['vehicle_type']['seats_number'];
           o['bus_type']=o['vehicle']['bus_type'];
          
           
         });
        setVehicles(objs);
       }else if(res.status==400){

       }
     }).catch(err=>{

      setLoadvehicle(false);
       if(err.message){
        enqueueSnackbar(err.message, { 
          variant: 'error',
      });
       }

       if(err.response){
        enqueueSnackbar(err.response.data.message, { 
          variant: 'error',
      });
       }
     
     });
   }


   // get vehicle type
   const [loadTypes,setLoadtypes]=useState(false);
   const [vehicleTypes,setVehicletypes]=useState([]);
   const get_vehicle_type=(token)=>{
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const vehicleInstance = axios.create(new AdminService().setHeaders(token));
    setLoadtypes(true);
    vehicleInstance.get("/api/v1/vehicle-types")
    .then(res=>{
      if(res.status==200){
        setVehicletypes(res.data['data']);
        setLoadtypes(false);
      }
      setLoadtypes(false);
    }).then(err=>{
      console.log(err);
    }).catch(err=>{

      setLoadtypes(false);

      if(err.message){
        enqueueSnackbar(err.message, { 
          variant: 'error',
      });
      }
    
      if(err.response){
        if(err.response.status==401){
          history.push("/", { expired: true });
          enqueueSnackbar(err.message, { 
            variant: 'error',
        });
        }
        if(err.response.status==404){
          enqueueSnackbar("No vehicle types available", { 
            variant: 'info',
        });
        }
      }
    
    
    });
   }

   // dialog add vehicle type 
   const [dialogType,setDialogtype]=useState(false);
   // add vehicle type 
   const [addVehicleLoad,setAddVehicleLoad]=useState(false);
   const [name,setName]=useState({value:"",error:""});
   const [seats,setSeats]=useState({value:0,error:""});
   const add_vehicle_type=()=>{
     if(name.value===""){
       setName({value:"",error:"Enter name"});
     }else if(seats.value===""){
       setSeats({value:0,error:"Enter seats number "});
     }else{
      axios.defaults.baseURL = new AdminService().BASE_URL;
      const addInstance = axios.create(new AdminService().setHeaders(operatorData.token));
      setAddVehicleLoad(true);
      addInstance.post("/api/v1/vehicle-type",
       {
        "name": name.value,
        "seats_number": seats.value
      }
       ).then(res=>{
         var obj=res.data.data;
         var objs=vehicleTypes;
         objs.unshift(obj);
         setVehiclesTypes(objs);

         if(res.status===200){
          enqueueSnackbar('Vehicle type added successful!', { 
            variant: 'success',
        });
          setDialogtype(false);
          // get_vehicle_type();
         }
         setAddVehicleLoad(false);
         
       })
     }
   }

/// get vehicle organization
const [typeLoad,setTypeLoad]=useState(false);
const [vehiclesTypes,setVehiclesTypes]=useState([]);
const get_type_vehicle=(id,titleType,capa)=>{
  setMessage("Loading...");
  setVehicles([]);
  setLoadvehicle(true);
  axios.defaults.baseURL = new AdminService().BASE_URL;
  const typeInstance = axios.create(new AdminService().setHeaders(operatorData.token));
  typeInstance.get('/api/v1/operator-vehicle/organization/'+new UserInfo().ORG_ID+'/vehicleType/'+id
  ).then(res=>{
    console.log("vehicle in specific type");
    console.log(res.data);
    res.data.data.length==0&&setMessage("No Vehicle available");
    var objs=res.data.data;
    objs.map((o)=>{
      o['id']=o['vehicle']['vehicle_id'];
      o['admin_id']=o['vehicle']['vehicle_id'];
      o['capacity']=capa;
      o['plate_number']=o['vehicle']['plate_number'];
      o['chassis_number']=o['vehicle']['chassis_number'];
      o['steering_side']=o['vehicle']['steering_side'];
      o['vehicle_type_id']=id;
      o['vehicle_type']=titleType;
    });

    setVehicles(objs);
    setLoadvehicle(false);
    setTypeLoad(false);
  }).catch(err=>{
    setLoadvehicle(false);
    setTypeLoad(false);
    console.log(err);
   
  if(err.response.status==404){
    setMessage("No vehicle available!");
    enqueueSnackbar("No vehicles in this category",
     { 
      variant: 'info',
  });
  }
  })
    
}


/// add vehicle 


const [addLoad,setAddLoad]=useState(false);
const [capacity,setCapacity]=useState({value:"",error:""});
const [chassisNumber,setChassisNumber]=useState({value:"",error:""});
const [plateNumber,setPlateNumber]=useState({value:"",error:""});
const [typeId,setTypeId]=useState({value:0,error:""});
const [steeringSide,setSteeringSide]=useState({value:"",error:""});
const [busType,setBusType]=useState({value:"EXPRESS",error:""});

const addVehicle=()=>{
  if(capacity.value=="" || parseInt(capacity.value)>99 || parseInt(capacity.value)<1 ){

    setCapacity({value:"",error:"Invalid capacity"})

  }else if(chassisNumber.value==""){

    setChassisNumber({value:"",error:"Enter chassis number"});

  }else if(plateNumber.value==""){

    setPlateNumber({value:"",error:"Enter platenumber"});

  }else if(typeId.value==0){

    setPlateNumber({value:"",error:"Select vehicle type"});

  }else if(steeringSide.value==""){

    setPlateNumber({value:"",error:"Select vehicle type"});

  }else{
    setAddLoad(true);
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const addInstance = axios.create(new AdminService().setHeaders(operatorData.token));
    addInstance.post('/api/v1/vehicle',{
      "capacity": capacity.value,
      "chassis_number": chassisNumber.value,
      "plate_number":plateNumber.value,
      "vehicle_type_id":typeId.value,
      "steering_side":steeringSide.value,
      "bus_type":busType.value
    }).then(res=>{
  
      var obj=res.data.data;
      setVehicleId(obj.vehicle_id);
  
      console.log(res.data.data.vehicle_id);
  
    assignVehicle(res.data.data.vehicle_id);
    
    }).catch(err=>{
      setAddLoad(false);
  console.log(err);

  console.log(err.response.data);

  enqueueSnackbar(err.response.data.message, { 
    variant: 'error',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
  },
});
    });
  }
  
}


// assign vehicle to organization


const assignVehicle=(id)=>{
  axios.defaults.baseURL = new AdminService().BASE_URL;
  const assignInstance = axios.create(new AdminService().setHeaders(operatorData.token));
  assignInstance.post('/api/v1/operator-vehicle',
  {
    "organization_id": new UserInfo().ORG_ID,
    "vehicle_id": id,
    "cooperative_member_id": member.value,
  }).then(res=>{
    console.log("============== assign vehicle====");
    console.log(res);
    var objs=vehicles;
    var obj=res.data.data;
    obj['id']=obj['vehicle']['vehicle_id'];
    obj['admin_id']=obj['vehicle']['vehicle_id'];
    obj['capacity']=obj['vehicle']['capacity'];
    obj['plate_number']=obj['vehicle']['plate_number'];
    obj['chassis_number']=obj['vehicle']['chassis_number'];
    obj['steering_side']=obj['vehicle']['steering_side'];
    obj['vehicle_type_id']=obj['vehicle']['vehicle_type_id'];

    objs.unshift(obj);

    setVehicles(objs);
 
    setOpen(false);
    setAddLoad(false);
    enqueueSnackbar('Vehicle added successful!', { 
      variant: 'success',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  });

  handleNext();

  // getVehicle(operatorData.token);

  }).catch(err=>{
    setAddLoad(false);
    console.log(err);
  });
}


/// get organization lisence


const [lisences,setLisences]=useState([]);
const get_lisences=(token)=>{
  axios.defaults.baseURL = new AdminService().BASE_URL;
  const lisencesInstance = axios.create(new AdminService().setHeaders(token));
  lisencesInstance.get('/api/v1/organization-license/organization/'+new UserInfo().ORG_ID)
  .then(res=>{
    console.log("lisences",res.data.data);
    var data=res.data.data.filter((l)=>l.license_status=="VALID");
    setLisences(data);
  }).catch(err=>{

    if(err.message){
      enqueueSnackbar(err.message,
         { 
          variant: 'info',
      });
    }
    if(err.response){
      if(err.response.status==404){
        enqueueSnackbar("No organization lisence available",
         { 
          variant: 'info',
      });
      }
    }
    
  });
}


// get routes 

const [routes,setRoutes]=useState([]);
const get_route=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const routeInstance = axios.create(new TransportService().setHeaders(token));
  routeInstance.get('/api/v1/integrations/getRoutesByOrganization/'+new UserInfo().ORG_ID)
  .then(res=>{
    setRoutes(res.data);
  }).catch(err=>{

    if(err.response){
      enqueueSnackbar(err.response.data.message,
        { 
         variant: 'info',
     }); 
    }

    if(err.message){
      enqueueSnackbar(err.message,
        { 
         variant: 'error',
     });
    }
    
  });
}



// add vehicle lisence

const [route,setRoute]=useState({value:0,error:""});
const [vehicleId,setVehicleId]=useState(0);
const [lisenceLoad,setLisenceLoad]=useState(false);
const [lisenceNumber,setLisenceNumber]=useState({value:"",error:""});
const [issueDate,setIssueDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [expiryDate,setExpiryDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [lisenceId,setLisenceId]=useState({value:0,error:""});

const add_vehicle_lisence=()=>{
  if(lisenceNumber.value==""){
    setLisenceNumber({value:"",error:"Enter lisence number"});
  }else if(issueDate.value==""){
    setIssueDate({value:"",error:"Select issued date"});
  }else if(expiryDate.value==""){
    setExpiryDate({value:"",error:"Select expiry date"});
  }else if(lisenceId.value==0){
    setLisenceId({value:"",error:"Select organisation lisence"});
  }else if(route.value==0){
    setRoute({value:0,error:"Select route"});
  }else{
    // console.log("expiry_date",expiryDate.value);
    // console.log("issue_date",issueDate.value);
    // console.log("license_number",lisenceNumber.value)
    // console.log("organization_license_id",lisenceId.value);
    // console.log("route_id", route.value);
    // console.log("vehicle_id",vehicleId);
    setLisenceLoad(true);
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const lisenceInstance = axios.create(new AdminService().setHeaders(operatorData.token));
    lisenceInstance.post('/api/v1/vehicle-license',
      {
        "expiry_date":expiryDate.value,
        "issue_date": issueDate.value,
        "license_number":lisenceNumber.value,
        "organization_license_id": lisenceId.value,
        "route_id": route.value,
        "vehicle_id": vehicleId
      }).then(res=>{
        handleCloseLisence();
        setLisenceLoad(false);
        enqueueSnackbar("Lisence added successful!",
          { 
           variant: 'success',
       });

       handleNext();

    }).catch(err=>{
      setLisenceLoad(false);
      enqueueSnackbar(err.message,
      { 
       variant: 'error',
   });
    });

  }
  
}



// create vehicle in steps


const [dialogStep,setDialogStep]=useState(false);

const [activeStep, setActiveStep] =useState(0);
  const steps = ['Add Vehicle', 'Assign lisence'];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

    // edit vehicle dialog 

    const [editDialog,setEditDialog]=useState(false);

    // remove vehicle from operator 

    const [removeDialog,setRemoveDialog]=useState(false);
    const [removeLoad,setRemoveLoad]=useState(false);
    
    const removeVehicle=()=>{

    }


  // // get vehicle details 
  // const [detailsLoad,setDetailsLoad]=useState(false);
  // const [vehicleDetails,setVehicleDetails]=useState({});
  // const get_vehicle_details=(id)=>{
  //   setDetailsLoad(true);
  //   const detailsInstance = axios.create(new AdminService().setHeaders(operatorData.token));
  //   detailsInstance.get('/admin-service/api/v1/vehicle/'+id)
  //   .then(res=>{
  //     var obj=res.data.data;
  //     setCapacity({value:obj.capacity,error:""});
  //     setPlateNumber({value:obj.plate_number,error:""});
  //     setChassisNumber({value:obj.chassis_number,error:""});
  //     setTypeId({value:obj.vehicle_type_id,error:""});
  //     setDetailsLoad(false);
  //     setEditDialog(true);
  //   })
  //   .catch(err=>{
  //     setDetailsLoad(false);
  //     enqueueSnackbar(err.message,
  //         { 
  //          variant: 'error',
  //      });
  //   });
  // }



// eidt vehicle 

const [editLoad,setEditLoad]=useState(false);
const edit_vehicle=()=>{
  if(capacity.value=="" || parseInt(capacity.value)>99 || parseInt(capacity.value)<1 ){

    setCapacity({value:"",error:"Invalid capacity"})

  }else if(chassisNumber.value==""){

    setChassisNumber({value:"",error:"Enter chassis number"});

  }else if(plateNumber.value==""){

    setPlateNumber({value:"",error:"Enter platenumber"});

  }else if(typeId.value==0){

    setPlateNumber({value:"",error:"Select vehicle type"});

  }else if(steeringSide.value==""){

    setPlateNumber({value:"",error:"Select vehicle type"});

  }else{
    setEditLoad(true);
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const vehicleInstance = axios.create(new AdminService().setHeaders(operatorData.token));
    vehicleInstance.put('/api/v1/vehicle/'+vehicleId,{
        "capacity": capacity.value,
        "chassis_number": chassisNumber.value,
        "plate_number": plateNumber.value,
        "vehicle_type_id": typeId.value,
        "steering_side":steeringSide.value,
        "bus_type":busType.value,
        
      })
    .then(res=>{
      console.log("response===== update",res.data.data);
      setEditLoad(false);
      setEditDialog(false);
      enqueueSnackbar("Vehicle updated successful!",
        { 
         variant: 'success',
     });

     var objs=vehicles;
     var index=vehicles.findIndex((o)=>o.id==vehicleId);
     var obj=res.data.data;
     var e_obj=objs[index];
     e_obj['capacity']=obj['capacity'];
     e_obj['plate_number']=obj['plate_number'];
     e_obj['chassis_number']=obj['chassis_number'];
     e_obj['steering_side']=obj['steering_side'];
     e_obj['vehicle_type_id']=obj['vehicle_type_id'];

     console.log("e_obj",e_obj);
 
     objs[index]=e_obj;
setVehicles([]);
     setVehicles(objs);
 

    })
    .catch(err=>{
      console.log("======error",err);
      setEditLoad(false);

      enqueueSnackbar(err.response.data.message,
        { 
         variant: 'error',
     });

    });
  }


}



// Edit vehicle type 



const [anchorEl, setAnchorEl] = React.useState(null);

const handleClick = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleCloseT = () => {
  setAnchorEl(null);
};

const openT = Boolean(anchorEl);
const id = openT ? 'simple-popover' : undefined;



const [vehicleTypeId,setVehicleTypeId]=useState(0);
const [vehicleName,setVehicleName]=useState({value:"",error:""});
const [typeCapacity,setTypeCapacity]=useState({value:0,error:""});

const [vehicleTypeLoad,setVehicleTypeLoad]=useState(false);

const upadate_type=()=>{
  if(vehicleName.value==""){
    setVehicleName({value:"",error:"Empty type name"});
  }else if(typeCapacity.value==0){
    setTypeCapacity({value:0,error:"Enter valid capacity"});
  }else{
    setVehicleTypeLoad(true);
    axios.defaults.baseURL = new AdminService().BASE_URL;
    const updateInstance = axios.create(new AdminService().setHeaders(operatorData.token));
    updateInstance.put('/api/v1/vehicle-type/'+vehicleTypeId,
    {
      "name":vehicleName.value,
      "seats_number": typeCapacity.value
    }).then(res=>{
      var objs=vehicleTypes;
      var obj=res.data.data;
      var index=objs.findIndex((o)=>o.vehicle_type_id==vehicleTypeId);
      objs[index]=obj;
      setVehicletypes(objs);

      setVehicleTypeLoad(false);
        enqueueSnackbar("Vehicle type updated successful!",
          { 
           variant: 'success',
       });
       handleCloseT();
    }).catch(err=>{
      setVehicleTypeLoad(false);
      enqueueSnackbar(err.message,
      { 
       variant: 'error',
   });
    });
  }
}




  return (
    <div className={classes.root}>

     <Box display="flex">
 
 <Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
 <Box mr={1}> <AirportShuttle fontSize="large" color="primary"/></Box> <Typography  variant="h5" color="default"><b><Translate id="operator_vehicle.vehicle" /></b></Typography>

 </Box>
 
 
<Button  
        className={classes.btn}
        size="small"
        startIcon={<Add/>} 
        onClick={()=>{
          setDialogStep(true);
        }} 
        variant="contained" 
        color="primary"
        disableElevation={true}>

<Typography noWrap><Translate id="operator_vehicle.form_new_vehicle.new_vehicle" /></Typography>
</Button>
 
     </Box>

 {/* vehicles table  */}
<Grid container>
<Grid md={4} xs={12} lg={4}>

  <Box mt={1} mr={1}>
   
  <Paper elevation={0}>
  {loadTypes&&<LinearProgress />}
  
  <Box display="flex" alignItems="center">
    <Box display="flex" className={classes.formTitle} ml={1}><Typography variant="h6">Vehicle Types</Typography></Box>
  <Box mt={1} mr={1}>
  <Button  
        className={classes.btn}
        size="small"
        startIcon={<Add/>} 
        onClick={()=>{setDialogtype(true);}} 
        variant="outlined" 
        color="primary"
        disableElevation={true}>

<Typography noWrap>New Vehicle type</Typography>
</Button>
  </Box>
 </Box>
  <List className={classes.type_list}>
    {vehicleTypes.map((vt)=>{
      return <ListItem onClick={()=>{
        setFilter(true);
        setTitle(vt['name']);
        get_type_vehicle(vt['vehicle_type_id'],vt['name'],vt['seats_number']);
      }} button>
      <ListItemAvatar>
          <AirportShuttle fontSize="large"/>
      </ListItemAvatar>
      <ListItemText primary={vt['name']} secondary={vt['seats_number']} />
      <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="delete" aria-describedby={id} onClick={(e)=>{
                      handleClick(e);
                      setVehicleName({value:vt['name'],error:""});
                      setVehicleTypeId(vt['vehicle_type_id']);
                      setTypeCapacity({value:vt['seats_number'],error:""});
                    }}>
                      <Edit />
                    </IconButton>

        {/* popever edit vehicle type */}

        <Popover
        id={id}
        open={openT}
        anchorEl={anchorEl}
        onClose={handleCloseT}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        elevation={1}
      >


<Box p={2}>
          <Typography color="textSecondary">
            Edit Vehicle Type
          </Typography>
          <Box mt={2} mb={2}>
            <TextField
            size="small"
              label="Type name"
              placeholder="Price"
              fullWidth
              variant="outlined"
              defaultValue={vehicleName.value}
              onChange={(e)=>{
                if(e.target.value==""){
                  setVehicleName({value:"",error:"Empty name"});
                }else{
                  setVehicleName({value:e.target.value,error:""});
                }

              }}
              type="text"
              error={vehicleName.error != ""}
              helperText={vehicleName.error}
            />
          </Box>

          <Box mt={2} mb={2}>
            <TextField
            size="small"
              label="Capacity"
              placeholder="Price"
              fullWidth
              variant="outlined"
              defaultValue={typeCapacity.value}
              onChange={(e)=>{
                if(e.target.value==0){
                  setTypeCapacity({value:0,error:"Enter valid seats"});
                }else{
                  setTypeCapacity({value:e.target.value,error:""});
                }
              }}
              type="number"
              error={typeCapacity.error != ""}
              helperText={typeCapacity.error}
            />
          </Box>

          <Button
            variant="outlined"
            size="small"
            color="primary"
            className={classes.btn2}
            onClick={handleCloseT}
          >
            Close
          </Button>

          <Button
            variant="contained"
            size="small"
            color="primary"
            className={classes.btn}
            disableElevation
            onClick={()=>{
              upadate_type();
            }}
          >
            {vehicleTypeLoad?<CircularProgress color="secondary" size={23} /> : "Save"}
          </Button>
        </Box>
    
  

      </Popover>
                  </ListItemSecondaryAction>
    </ListItem>
    })}
    </List>
  </Paper>
  
  </Box>
   </Grid>
  <Grid md={8} xs={12} lg={8}>
  <Box mt={1}>
 {loadVehicle&&<LinearProgress />}
 <MUIDataTable
  title={title}
  data={vehicles}
  columns={columns}
  options={options}
/>
 
</Box> 
  </Grid>
</Grid>
 

{/* dialog new vehicle  */}



    <Dialog
    maxWidth="sm"
    fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle id="new branch">{"New Vehicle"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box>
              <Box display="flex" alignItems="center" justifyContent="center">
                <TextField
                  size="small"
                  variant="outlined"
                  label={
                    <Translate id="operator_vehicle.form_new_vehicle.plate_number" />
                  }
                  onChange={(e)=>{
                    if(e.target.value===""){
                      setPlateNumber({value:"",error:"Enter plate number"});
                    }else{
                      setPlateNumber({value:e.target.value,error:"Enter plate number"});
                    }
                  }}

                  color="primary"
                  fullWidth
                />
              </Box>
              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <TextField
                  size="small"
                  variant="outlined"
                  label={
                    <Translate id="operator_vehicle.form_new_vehicle.capacity" />
                  }
                  type="number"
                  onChange={(e)=>{
                    if(e.target.value===""){
                      setCapacity({value:"",error:"Enter capacity"});
                    }else{
                      setCapacity({value:e.target.value,error:"Enter capacity"});
                    }
                  }}
                  color="primary"
                  fullWidth
                />
              </Box>
              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <TextField
                  size="small"
                  variant="outlined"
                  type="number"
                  label={
                    <Translate id="operator_vehicle.form_new_vehicle.chessis_number" />
                  }
                  onChange={(e)=>{
                    if(e.target.value===""){
                      setChassisNumber({value:"",error:"Enter chassis number"});
                    }else{
                      setChassisNumber({value:e.target.value,error:"Enter chassis number"});
                    }
                  }}
                  color="primary"
                  fullWidth
                />
              </Box>

              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="type">
                    <Translate id="operator_vehicle.form_new_vehicle.choose_vehicle" />
                  </InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select type"
                    inputProps={{
                      name: "type",
                      id: "type",
                    }}
                    onChange={(e)=>{
                      if(e.target.value===0){
                        setTypeId({value:0,error:"Enter chassis number"});
                      }else{
                        setTypeId({value:e.target.value,error:"Enter chassis number"});
                      }
                    }}
                  >

                    <MenuItem value="0">
                      <em>None</em>
                    </MenuItem>
                    {vehicleTypes.map((vt)=>{
                      return <MenuItem value={vt['vehicle_type_id']}>{vt['name']}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          


          <Button onClick={handleClose}   color="secondary" >
            <Translate id="operator_vehicle.form_new_vehicle.cancel" />
          </Button>

          <Button
            disableElevation
            
            variant="contained"
            color="primary"
            onClick={()=>{
              addVehicle();
            }}
            autoFocus
          >
            {addLoad?<CircularProgress size={25}/>:<Translate id="operator_vehicle.form_new_vehicle.save" />}
          </Button>

        </DialogActions>
      </Dialog>

      {/* dialog add lisence  */}

      <Dialog
        maxWidth="sm"
        fullWidth
        open={openLisence}
        onClose={handleCloseLisence}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle id="new branch">
          {" "}
          <Translate id="operator_vehicle.form_add_lisence.add_lisence" />{" "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box>
              <Box display="flex" alignItems="center" justifyContent="center">
                <TextField
                  size="small"
                  variant="outlined"
                  label={
                    <Translate id="operator_vehicle.form_add_lisence.lisence_number" />
                  }
                  color="primary"
                  fullWidth
                  error={lisenceNumber.error!=""}
                  helperText={lisenceNumber.error}
                  onChange={(e)=>{
                    if(e.target.value==""){
                      setLisenceNumber({value:"",error:"Enter lisence"});
                    }else{
                      setLisenceNumber({value:e.target.value,error:""});
                    }
                  }}
                />
              </Box>
              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    variant="inline"
                    inputVariant="outlined"
                    margin="normal"
                    format="yyyy-MM-dd" 
                    label="Issued date"
                    autoOk
                    value={issueDate.value}
                    onChange={(v)=>{
                      setIssueDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    fullWidth
                  />
                </MuiPickersUtilsProvider>
              </Box>

              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    variant="inline"
                    inputVariant="outlined"
                    margin="normal"
                    autoOk
                    label={
                      <Translate id="operator_vehicle.form_add_lisence.expiriy_date" />
                    }
                    format="yyyy-MM-dd"
                    value={expiryDate.value}
                    onChange={(v)=>{
                      setExpiryDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    fullWidth
                  />
                </MuiPickersUtilsProvider>
              </Box>

              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="type">
                    <Translate id="operator_vehicle.form_add_lisence.choose_organization_lisence" />
                  </InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select type"
                    inputProps={{
                      name: "type",
                      id: "type",
                    }}
                    onChange={(e)=>{
                      if(e.target.value==0){
                        setLisenceId({value:0,error:"Select organization lisence"});
                      }else{
                        setLisenceId({value:e.target.value,error:""});
                      }
                    }}
                  >
                    <MenuItem value={0}>
                      <em>None</em>
                    </MenuItem>
                    {lisences.map((l)=>{
                      return <MenuItem value={l.organization_license_id}>{l.license_number+"("+l.routes+")"}</MenuItem>;
                    })}
                  </Select>
                  <FormHelperText error={lisenceId.error!=""}>{lisenceId.error}</FormHelperText>
                </FormControl>
                </Box>


                <Box mt={1}>
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="type">
                   Select Route
                  </InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select route"
                    inputProps={{
                      name: "type",
                      id: "type",
                    }}
                    onChange={(e)=>{
                      if(e.target.value==0){
                        setRoute({value:0,error:"Select organization lisence"});
                      }else{
                        setRoute({value:e.target.value,error:""});
                      }
                    }}
                  >
                    <MenuItem value={0}>
                      <em>None</em>
                    </MenuItem>
                    {routes.map((r)=>{
                      return <MenuItem value={r.admin_id}>{r.name}</MenuItem>;
                    })}
                  </Select>
                  <FormHelperText error={route.error!=""}>{route.error}</FormHelperText>
                </FormControl>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
   
          <Button onClick={handleCloseLisence} color="secondary" >
            <Translate id="operator_vehicle.form_add_lisence.cancel" />
          </Button>

          <Button
          autoFocus
            disableElevation
            onClick={()=>{
              add_vehicle_lisence();
            }}
            variant="contained"
            color="primary"
          >
            {lisenceLoad?<CircularProgress size={25} color="secondary"/>:<Translate id="operator_vehicle.form_add_lisence.save"/>}
          </Button>


        </DialogActions>
      </Dialog>

 {/* dialog add vehicle type */}

 <Dialog
        maxWidth="sm"
        fullWidth
        open={dialogType}
        onClose={()=>{
          setDialogtype(false);
        }}
        aria-labelledby="add vehicle type"
        aria-describedby="add vehicle type"
      >
        <DialogTitle id="add_vehicle_type">
          <Typography>Add vehicle type</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>

          <Box>
              <Box display="flex" alignItems="center" justifyContent="center">
                <TextField
                  size="small"
                  variant="outlined"
                  label={"Name"}
                  color="primary"

                  error={name.error!=""}
                  helperText={name.error}
                  onChange={(e)=>{
                    if(e.target.value===""){
                      setName({value:"",error:"Enter name"});
                    }else{
                      setName({value:e.target.value,error:""});
                    }
                  }}
                  fullWidth
                />
              </Box>
              <Box mt={1} display="flex" alignItems="center" justifyContent="center">
                <TextField
                type="number"
                  size="small"
                  variant="outlined"
                  label={"Total seats"}
                  color="primary"
                  error={seats.error!=""}
                  helperText={seats.error}
                  onChange={(e)=>{
                    if(e.target.value===""){
                      setSeats({value:0,error:"Enter name"});
                    }else{
                      setSeats({value:e.target.value,error:""});
                    }
                  }}
                  fullWidth
                />
              </Box>
              </Box>

            </DialogContentText>
            </DialogContent>


            <DialogActions>
          <Button
            disableElevation
            onClick={()=>{
              setDialogtype(false);
            }}
            variant="outlined"
            color="primary"
          >
           <Typography>Cancel</Typography>
          </Button>
          <Button onClick={()=>{
            add_vehicle_type();
          }} color="primary" variant="contained" autoFocus>
            {addVehicleLoad?<CircularProgress size={25}/>:<Typography>Save</Typography>}
         
          </Button>
        </DialogActions>
        </Dialog>



{/* add vehicle with lisence in steps  */}



<Dialog
        maxWidth="sm"
        minHeight={200}
        fullWidth
        open={dialogStep}
        onClose={()=>{
          setDialogStep(false);
        }}
        aria-labelledby="assign_user"
        aria-describedby="assign_user"
      >
        <DialogTitle id="assign_user">Add New Vehicle</DialogTitle>
        <DialogContent>
          <DialogContentText >
        


          <Stepper activeStep={activeStep} alternativeLabel>


        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}


      </Stepper>
      <Box>
        {activeStep === steps.length ? (
          <Box>
            <Typography >All steps completed</Typography>
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        ) : (
          <Box>
            <Typography >
              
              
              {/* {getStepContent(activeStep)} */}
              {
                activeStep==0&&
   
                <Box>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <TextField
                    size="small"
                    variant="outlined"
                    label={
                      <Translate id="operator_vehicle.form_new_vehicle.plate_number" />
                    }
                    onChange={(e)=>{
                      if(e.target.value===""){
                        setPlateNumber({value:"",error:"Enter plate number"});
                      }else{
                        setPlateNumber({value:e.target.value,error:""});
                      }
                    }}
                    error={plateNumber.error!=""}
                    helperText={plateNumber.error}
  
                    color="primary"
                    fullWidth
                  />
                </Box>
                {/* <Box
                  mt={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <TextField
                    size="small"
                    variant="outlined"
                    label={
                      <Translate id="operator_vehicle.form_new_vehicle.capacity" />
                    }
                    type="number"
                    onChange={(e)=>{
                      if(e.target.value==0 || e.target.value<1 ||  e.target.value>99){
                        setCapacity({value:"",error:"Invalid capacity"});
                      }else{
                        setCapacity({value:e.target.value,error:""});
                      }
                    }}
                    value={capacity.value}
                    error={capacity.error!=""}
                    helperText={capacity.error}
                    color="primary"
                    fullWidth
                  />
                </Box> */}
                <Box
                  mt={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <TextField
                    size="small"
                    variant="outlined"
                    type="text"
                    label={
                      <Translate id="operator_vehicle.form_new_vehicle.chessis_number" />
                    }
                    onChange={(e)=>{
                      if(e.target.value===""){
                        setChassisNumber({value:"",error:"Enter chassis number"});
                      }else{
                        setChassisNumber({value:e.target.value,error:""});
                      }
                    }}
                    error={chassisNumber.error!=""}
                    helperText={chassisNumber.error}
                    color="primary"
                    fullWidth
                  />
                </Box>


                <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="type">
                    Steering side
                  </InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select steering type"
                    defaultValue={steeringSide.value}
                    inputProps={{
                      name: "type",
                      id: "type",
                    }}
                    onChange={(e)=>{
                      if(e.target.value===0){
                        setSteeringSide({value:"",error:"Select steering type"});
                      }else{
                        setSteeringSide({value:e.target.value,error:""});
                      }
                    }}
                  >

                    <MenuItem value="0">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"LEFT"}>Left</MenuItem>
                    <MenuItem value={"RIGHT"}>Right</MenuItem>
                  </Select>
                </FormControl>
              </Box>
        

              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="type2">
                    Bus type
                  </InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select bus type"
                    defaultValue={busType.value}
                    inputProps={{
                      name: "type2",
                      id: "type2",
                    }}
                    onChange={(e)=>{
                      if(e.target.value===0){
                        setBusType({value:"",error:"Select bus type"});
                      }else{
                        setBusType({value:e.target.value,error:""});
                      }
                    }}
                  >

                    <MenuItem value={"EXPRESS"}>EXPRESS</MenuItem>
                    <MenuItem value={"MINIBUS"}>MINIBUS</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              {new UserInfo().ORG_TP=='COOPERATIVE' || new UserInfo().ORG_TYPE=='COOPERATIVE'?<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="tole">Cooperative member</InputLabel>
<Select
size="small"
helperText={member.error} 
label="Select member"
inputProps={{
  name: 'member',
  id: 'member',
}}
error={member.error!==""}
onChange={(e)=>{
  if(e.target.value===''){
    setMember({value:"",error:"Select member"});
  }else{
    setMember({value:e.target.value,error:""});
  }
}}
>
  <MenuItem value="">
    <em>None</em>
  </MenuItem>
  {members.map((r)=>{
    return <MenuItem value={r['cooperative_member_id']}>{r['user_first_name']+" "+r['user_last_name']}</MenuItem>;
  })}
  
</Select>
<FormHelperText error={member.error!==""}>{member.error}</FormHelperText>
</FormControl>
</Box>:<></>}
  
                <Box
                  mt={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <FormControl
                    size="small"
                    variant="outlined"
                    fullWidth
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="type">
                      <Translate id="operator_vehicle.form_new_vehicle.choose_vehicle" />
                    </InputLabel>
                    <Select
                      size="small"
                      helperText={"error"}
                      label="Select type"
                      inputProps={{
                        name: "type",
                        id: "type",
                      }}
                      onChange={(e)=>{
                        if(e.target.value===0){
                          setTypeId({value:0,error:"Choose vehicle type"});
                        }else{
                          var id=e.target.value;
                          setTypeId({value:e.target.value,error:""});
                          var obj=vehicleTypes.find((o)=>o.vehicle_type_id==id);
                          setCapacity({value:obj['seats_number'],error:""});
                          
                        }
                      }}
                    >
  
                      <MenuItem value="0">
                        <em>None</em>
                      </MenuItem>
                      {vehicleTypes.map((vt)=>{
                        return <MenuItem value={vt['vehicle_type_id']}>{vt['name']}</MenuItem>
                      })}
                    </Select>
                    <FormHelperText error={typeId.error!=""}>{typeId.error}</FormHelperText>
                  </FormControl>
                </Box>
              </Box>
            
              }
              {
                activeStep==1&&
                
                <Box>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <TextField
                    size="small"
                    variant="outlined"
                    label={
                      <Translate id="operator_vehicle.form_add_lisence.lisence_number" />
                    }
                    color="primary"
                    fullWidth
                    error={lisenceNumber.error!=""}
                    helperText={lisenceNumber.error}
                    onChange={(e)=>{
                      if(e.target.value==""){
                        setLisenceNumber({value:"",error:"Enter lisence"});
                      }else{
                        setLisenceNumber({value:e.target.value,error:""});
                      }
                    }}
                  />
                </Box>
                <Box
                  mt={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      variant="inline"
                      inputVariant="outlined"
                      margin="normal"
                      format="yyyy-MM-dd" 
                      label="Issued date"
                      autoOk
                      label={
                        <Translate id="operator_vehicle.form_add_lisence.issue_date" />
                      }
                      format="yyyy-MM-dd"
                      value={issueDate.value}
                      onChange={(v)=>{
                        setIssueDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      fullWidth
                    />
                  </MuiPickersUtilsProvider>
                </Box>
  
                <Box
                  mt={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      variant="inline"
                      inputVariant="outlined"
                      margin="normal"
                      autoOk
                      label={
                        <Translate id="operator_vehicle.form_add_lisence.expiriy_date" />
                      }
                      format="yyyy-MM-dd"
                      value={expiryDate.value}
                      onChange={(v)=>{
                        setExpiryDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      fullWidth
                    />
                  </MuiPickersUtilsProvider>
                </Box>
  
                <Box
                  mt={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <FormControl
                    size="small"
                    variant="outlined"
                    fullWidth
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="type">
                      <Translate id="operator_vehicle.form_add_lisence.choose_organization_lisence" />
                    </InputLabel>
                    <Select
                      size="small"
                      helperText={"error"}
                      label="Select type"
                      inputProps={{
                        name: "type",
                        id: "type",
                      }}
                      onChange={(e)=>{
                        if(e.target.value==0){
                          setLisenceId({value:0,error:"Select organization lisence"});
                        }else{
                          setLisenceId({value:e.target.value,error:""});
                        }
                      }}
                    >
                      <MenuItem value={0}>
                        <em>None</em>
                      </MenuItem>
                      {lisences.map((l)=>{
                        return <MenuItem value={l.organization_license_id}>{l.license_number+"("+l.routes+")"}</MenuItem>;
                      })}
                    </Select>
                    <FormHelperText error={lisenceId.error!=""}>{lisenceId.error}</FormHelperText>
                  </FormControl>
                  </Box>
  
  
                  <Box mt={1}>
                  <FormControl
                    size="small"
                    variant="outlined"
                    fullWidth
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="type">
                     Select Route
                    </InputLabel>
                    <Select
                      size="small"
                      helperText={"error"}
                      label="Select route"
                      inputProps={{
                        name: "type",
                        id: "type",
                      }}
                      onChange={(e)=>{
                        if(e.target.value==0){
                          setRoute({value:0,error:"Select organization lisence"});
                        }else{
                          setRoute({value:e.target.value,error:""});
                        }
                      }}
                    >
                      <MenuItem value={0}>
                        <em>None</em>
                      </MenuItem>
                      {routes.map((r)=>{
                        return <MenuItem value={r.admin_id}>{r.name}</MenuItem>;
                      })}
                    </Select>
                    <FormHelperText error={route.error!=""}>{route.error}</FormHelperText>
                  </FormControl>
                </Box>
              </Box>
           

              }
              
              </Typography>

            <Box mt={2}>
              <Button
                disabled={activeStep === 0}
                onClick={handleBack}
                
              >
                Back
              </Button>
              <Button variant="contained" color="primary"
              
              onClick={()=>{
                console.log("step",activeStep);
                if(activeStep === 1){
                  add_vehicle_lisence();
                }else{
                  addVehicle();
                }
                 }
                 }>
                {activeStep === steps.length - 1 ? lisenceLoad?<CircularProgress size={25} color="secondary" />:'Save' :addLoad?<CircularProgress size={25} color="secondary" />:'Next'}
              </Button>
            </Box>
          </Box>
        )}
      </Box>

            </DialogContentText>
          </DialogContent>
          <DialogActions>
          
          <Button  className={classes.btn} onClick={()=>{
          setDialogStep(false);
          }} color="secondary" >
          Cancel
          </Button>

        </DialogActions>
</Dialog>



{/* dialog edit vehicle  */}


<Dialog
    maxWidth="sm"
    fullWidth
        open={editDialog}
        onClose={()=>{
          setEditDialog(false);
        }}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle id="new branch">{"Edit Vehicle"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            
            <Box>
              <Box display="flex" alignItems="center" justifyContent="center">
                <TextField
                  size="small"
                  variant="outlined"
                  value={plateNumber.value}
                  label={
                    <Translate id="operator_vehicle.form_new_vehicle.plate_number" />
                  }
                  onChange={(e)=>{
                    if(e.target.value===""){
                      setPlateNumber({value:"",error:"Enter plate number"});
                    }else{
                      setPlateNumber({value:e.target.value,error:"Enter plate number"});
                    }
                  }}

                  color="primary"
                  fullWidth
                />
              </Box>
              {/* <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <TextField
                  size="small"
                  variant="outlined"
                  value={capacity.value}
                  label={
                    <Translate id="operator_vehicle.form_new_vehicle.capacity" />
                  }
                  type="number"
                  onChange={(e)=>{
                    if(e.target.value===""){
                      setCapacity({value:"",error:"Enter capacity"});
                    }else{
                      setCapacity({value:e.target.value,error:"Enter capacity"});
                    }
                  }}
                  color="primary"
                  fullWidth
                />
              </Box> */}
              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <TextField
                  size="small"
                  variant="outlined"
                  type="text"

                  value={chassisNumber.value}
                  label={
                    <Translate id="operator_vehicle.form_new_vehicle.chessis_number" />
                  }
                  onChange={(e)=>{
                    if(e.target.value===""){
                      setChassisNumber({value:"",error:"Enter chassis number"});
                    }else{
                      setChassisNumber({value:e.target.value,error:"Enter chassis number"});
                    }
                  }}
                  color="primary"
                  fullWidth
                />
              </Box>
              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="type">
                    Steering side
                  </InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select steering type"
                    defaultValue={steeringSide.value}
                    inputProps={{
                      name: "type",
                      id: "type",
                    }}
                    onChange={(e)=>{
                      if(e.target.value===0){
                        setSteeringSide({value:"",error:"Select steering type"});
                      }else{
                        setSteeringSide({value:e.target.value,error:""});
                      }
                    }}
                  >

                    <MenuItem value="0">
                      <em>None</em>
                    </MenuItem>
                    <MenuItem value={"LEFT"}>Left</MenuItem>
                    <MenuItem value={"RIGHT"}>Right</MenuItem>
                  </Select>
                </FormControl>
              </Box>
        
              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="type2">
                    Bus type
                  </InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select bus type"
                    defaultValue={busType.value}
                    inputProps={{
                      name: "type2",
                      id: "type2",
                    }}
                    onChange={(e)=>{
                      if(e.target.value===0){
                        setBusType({value:"",error:"Select bus type"});
                      }else{
                        setBusType({value:e.target.value,error:""});
                      }
                    }}
                  >

                    <MenuItem value={"EXPRESS"}>EXPRESS</MenuItem>
                    <MenuItem value={"MINIBUS"}>MINIBUS</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              {new UserInfo().ORG_TP=='COOPERATIVE' || new UserInfo().ORG_TYPE=='COOPERATIVE'?<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
<InputLabel htmlFor="tole">Cooperative member</InputLabel>
<Select
size="small"
helperText={member.error} 
label="Select member"
inputProps={{
  name: 'member',
  id: 'member',
}}
error={member.error!==""}
onChange={(e)=>{
  if(e.target.value===''){
    setMember({value:"",error:"Select member"});
  }else{
    setMember({value:e.target.value,error:""});
  }
}}
>
  <MenuItem value="">
    <em>None</em>
  </MenuItem>
  {members.map((r)=>{
    return <MenuItem value={r['cooperative_member_id']}>{r['user_first_name']+" "+r['user_last_name']}</MenuItem>;
  })}
  
</Select>
<FormHelperText error={member.error!==""}>{member.error}</FormHelperText>
</FormControl>
</Box>:<></>}
              <Box
                mt={1}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <FormControl
                  size="small"
                  variant="outlined"
                  fullWidth
                  className={classes.formControl}
                >
                  <InputLabel htmlFor="type">
                    <Translate id="operator_vehicle.form_new_vehicle.choose_vehicle" />
                  </InputLabel>
                  <Select
                    size="small"
                    helperText={"error"}
                    label="Select type"
                    defaultValue={typeId.value}
                    inputProps={{
                      name: "type",
                      id: "type",
                    }}
                    onChange={(e)=>{
                      if(e.target.value===0){
                        setTypeId({value:0,error:"Select type"});
                      }else{
                          var id=e.target.value;
                          setTypeId({value:e.target.value,error:""});
                          var obj=vehicleTypes.find((o)=>o.vehicle_type_id==id);
                          setCapacity({value:obj['seats_number'],error:""});
                      }
                    }}
                  >

                    <MenuItem value="0">
                      <em>None</em>
                    </MenuItem>
                    {vehicleTypes.map((vt)=>{
                      return <MenuItem value={vt['vehicle_type_id']}>{vt['name']}</MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          


          <Button onClick={()=>{
            setEditDialog(false);
          }}   color="secondary" >
            <Translate id="operator_vehicle.form_new_vehicle.cancel" />
          </Button>

          <Button
            disableElevation
            
            variant="contained"
            color="primary"
            onClick={()=>{
              edit_vehicle();  
            }}
            autoFocus
          >
            {editLoad?<CircularProgress size={25}/>:<Translate id="operator_vehicle.form_new_vehicle.save" />}
          </Button>

        </DialogActions>
      </Dialog>




    </div>
  );
}

export default withLocalize(Vehicle);
